import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { coventryConfig } from "./data";

export default function CoventryPage() {
  return <CityPageTemplate config={coventryConfig} />;
}